// extracted by mini-css-extract-plugin
export default {"add-btn":"AddAdvantages_add-btn__T2RMa","form":"AddAdvantages_form__6v+dL","form-group":"AddAdvantages_form-group__eIEey"};